module.exports = __webpack_public_path__ + "static/img/stu-top.1b04367c.png";